import { render } from "./ModalHeader.vue?vue&type=template&id=23bd24a6"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ModalHeader.vue"]])

export default __exports__